import { render, staticRenderFns } from "./CreateBarrage.vue?vue&type=template&id=3b8544a6&scoped=true&"
import script from "./CreateBarrage.vue?vue&type=script&lang=js&"
export * from "./CreateBarrage.vue?vue&type=script&lang=js&"
import style0 from "./CreateBarrage.vue?vue&type=style&index=0&id=3b8544a6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b8544a6",
  null
  
)

export default component.exports